/**
 * Inicializa un MutationObserver para modificar enlaces de BambooHR
 */
export const initBambooObserver = () => {
  const observer = new MutationObserver(() => {
    const links = document.querySelectorAll('.BambooHR-ATS-Jobs-Item a');

    if (links.length) {
      links.forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });

      observer.disconnect(); // dejamos de observar
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};